module.exports = __webpack_public_path__ + "static/media/homepage-1.ebf03dec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage-1.png
// module id = 1059
// module chunks = 1